{
  "credits": {
    "ledger": {
      "signupGift": "هدیه ثبت‌نام",
      "topUp": "شارژ {{amount}} {{coin}}",
      "storePurchase": "خرید {{amount}} {{coin}} از {{store}}",
      "giftCode": "کد هدیه {{code}}",
      "prize": "جایزهٔ گردونه",
      "gift": "اعتبار هدیه",
      "stores": {
        "bazaar": "کافه‌بازار"
      }
    }
  }
}
